import React from 'react';
import { js_utils } from '../utils/frfr-js-utils';
import { virtel_schema_smart_get, _virtel_schema_field_get } from '../ter/ter-virtel-definition-lib';
import { _podeli_virtel_na_sections, _sort_virtel_sect_keys } from '../ter/ter-virtel-utils';
import JSDisplayValue from './JSDisplayValue';
import JSDisplayWidgetCollapsibleHeight from './JSDisplayWidgetCollapsibleHeight';
import ColumnWidthMinimize from './ColumnWidthMinimize';
import { sorted_priority_virtel_fields_keys } from '../ter/ter-virtel-definition-lib-fields';
import { ter_prevodilac, ter_recnik_kljuceva_smart_get } from '../ter/ter-multitranslator-lib';
import { multitranslator_v1_get_recnik_entity, multitranslator_v2_get_multiprevodJednogKljuca } from '../ter/ter-multitranslator-utils';


//
const _make_recnik_entity_cells_jsx = (recnik_entity) => {
  // console.log('recnik_entity', recnik_entity);
  const jsxExtraCells = (
    <>
      {
        recnik_entity && 'sasint_key' in recnik_entity ? (
          <td className="uu-text-nowrap">{recnik_entity.sasint_key}</td>
        ) : (
          <td className="td-multitranslations--blank"></td>
        )
      }
      {
        /*
        recnik_entity && 'sasint_value' in recnik_entity ? (
          <td className="uu-text-nowrap">{recnik_entity.sasint_value}</td>
        ) : (
          <td className="td-multitranslations--blank"></td>
        )
        */
      }
      {
        recnik_entity && 'sasexcel_key' in recnik_entity ? (
          <td className="uu-text-nowrap">{recnik_entity.sasexcel_key}</td>
        ) : (
          <td className="td-multitranslations--blank"></td>
        )
      }
      {
        recnik_entity && 'cncvars_key' in recnik_entity ? (
          <td className="uu-text-nowrap">{recnik_entity.cncvars_key}</td>
        ) : (
          <td className="td-multitranslations--blank"></td>
        )
      }
      {
        /*
        recnik_entity && 'cncvars_value' in recnik_entity ? (
          <td className="uu-text-nowrap">{recnik_entity.cncvars_value}</td>
        ) : (
          <td className="td-multitranslations--blank"></td>
        )
        */
      }
    </>
  );
  return jsxExtraCells;
};


// DEFAULT COMPONENT
const JSDisplayObjectVirtel = (props) => {
  // TODO: zastiti od pogresnih argumenata

  let obj = props.val; // plitki object
  ////
  // TEST multitransalator
  let recnik = false;
  /*
  if (obj.virtelclass === "terkk$ppv$sekcija") {
    const virtel = obj;
    recnik = ter_prevodilac.ppv_sekcija(virtel);
    console.log('recnik ppv_sekcija', recnik);
  }
  */
  let is_jezik = false;
  let multiprevodJednogKljuca = null;
  let recnik_kljuceva = false;
  let _jezik = '';
  if (typeof obj.multitranslator_lang === 'string' && obj.multitranslator_lang !== '') {
    _jezik = obj.multitranslator_lang;
    is_jezik = true;
    // multiprevodJednogKljuca = _novi_prevodilac_testing();
    recnik_kljuceva = ter_recnik_kljuceva_smart_get(_jezik);
  }
  // console.log('------***** recnik_kljuceva', recnik_kljuceva);
  recnik = recnik_kljuceva;
  ////
  /*
  if (!js_utils.is_object(virtel)) {
    virtel = {};
  }
  */
  // console.log(obj);
  // console.log(obj.virtelschemakey);
  const sema = virtel_schema_smart_get(obj.virtelschemakey);
  // console.log('sema', sema);
  // console.log('sema.fields', sema.fields);
  // console.log(Array.isArray(sema.fields));
  let sema_program;
  if (sema.program) {
    sema_program = sema.program;
  }


  // console.log(sema);
  // console.log('%c **********', 'background: #222; color: #bada55');
  const virtel_sect = _podeli_virtel_na_sections(obj, sema);

  /*
  let arr = [];
  for (const [key_sect, value_sect] of Object.entries(virtel_sect)) {
    // // console.log(`${key}: ${value}`);
    for (const [key, value] of Object.entries(value_sect)) {
      if (true) {
        // TODO ovde dodeljivati css klase za celije razlicitih sect-ova
      }
      arr.push({
        key: key,
        value: value,
        sect: key_sect
      });
    }
  }
  */

  /*
  _sort_virtel_sect_keys()
  sorted_priority_virtel_fields_keys
  */
  let arr = [];
  for (const [key_sect, value_sect] of Object.entries(virtel_sect)) {
    // // console.log(`${key}: ${value}`);
    const sect_keys = Object.keys(value_sect);
    const sorted_sect_keys = _sort_virtel_sect_keys(sect_keys, sorted_priority_virtel_fields_keys);
    // console.log('sorted_priority_virtel_fields_keys', sorted_priority_virtel_fields_keys);
    // for (const [key, value] of Object.entries(value_sect)) {
    for (const key of sorted_sect_keys) {
      const value = value_sect[key];
      if (true) {
        // TODO ovde dodeljivati css klase za celije razlicitih sect-ova
      }
      arr.push({
        key: key,
        value: value,
        sect: key_sect
      });
    }
  }


  // console.log(arr);
  let jsxProgramRow = (
    <tr key={'programrow'} className={"sect sect_header not-sect"}>
      <td className="sect">* sema.program</td>
      <td className="th"></td>
      <td className="th"></td>
      <td className="val"><JSDisplayValue val={sema_program} /></td>
      <td className="th"></td>
      <td className="th"></td>
      <td className="th"></td>

      {
        recnik !== false && (
          <>
            <td className="td-multitranslations--blank"></td>
            {/*<td className="td-multitranslations--blank"></td>*/}
            <td className="td-multitranslations--blank"></td>
            <td className="td-multitranslations--blank"></td>
            {/*<td className="td-multitranslations--blank"></td>*/}
          </>
        )
      }
    </tr>
  );
  let jsxTableRows = arr.map((el) => {
    let key = el.key;
    // console.log(el);
    let value = el.value;
    let sect = el.sect;
    // let pods = _get_pods_from_virtel_schema_by_field_name(sema, key);
    let field = _virtel_schema_field_get(key, sema);
    let field_type = field.type;
    let field_size = field.size;
    let field_digitsafterdecimalpoint = field.digitsafterdecimalpoint;
    /*
    let jsxType = null;
    if (typeof field_type === 'string') {
      jsxType = field_type + ', ' + field_size; // INTEGER, 11
    }
    */
    let field_pods = {};
    if (js_utils.is_object(field.pods)) {
      field_pods = field.pods;
    }
    let jsxPods = (
      <div className="red">UNDEF</div>
    );
    const pods_keys = Object.keys(field_pods).filter((pods_key) => {
      if (field_pods[pods_key] === true) {
        return true;
      }
      return false;
    });
    jsxPods = pods_keys.map((pods_key) => {
      return (
        <div key={pods_key} className="js-widget-tag js-widget-tag--virtel-pods-tag"><span className={pods_key}>{pods_key}</span></div>
      );
    });

    // const recnik_entity = multitranslator_v1_get_recnik_entity(recnik, "virtel_key", key);
    const multiprevodJednogKljuca = multitranslator_v2_get_multiprevodJednogKljuca(recnik_kljuceva, "virtel_key", _jezik, "virtel_key", key);
    const recnik_entity = multiprevodJednogKljuca;

    return (
      <tr key={sect + key} className={"sect " + sect}>
        <td className="sect">{sect}</td>
        <td className="pods">{jsxPods}</td>
        <td className="frfr-js-table__keyval-row__key">{key}</td>
        <td className="frfr-js-table__keyval-row__val"><JSDisplayValue val={value} /></td>
        <td className="type">
          {
            typeof field_type === 'string' ? (
              <div className={"js-widget-tag js-widget-tag--data-type"}><span className={field_type}>{field_type}</span></div>
            ) : (
              <JSDisplayValue val={field_type} />
            )
          }
        </td>
        <td className="size"><JSDisplayValue val={field_size} /></td>
        <td className="size">
          {
            (field_digitsafterdecimalpoint === 0 || field_digitsafterdecimalpoint > 0) ? (<JSDisplayValue val={field_digitsafterdecimalpoint} />) : (null)
          }
        </td>

        {
          recnik_kljuceva !== false && (
            _make_recnik_entity_cells_jsx(recnik_entity)
          )
        }
      </tr>
    );
  });


  let jsxTableRowsRecnikExtraArr = [];
  /*
  if (recnik !== false) {
    jsxTableRowsRecnikExtraArr = recnik.extra_arr.map((recnik_entity, index) => {
      return (
        <tr key={'extra_arr' + index}>
          <td></td>
          <td></td>
          <td className="td-multitranslations--blank"></td>
          <td className="val"><JSDisplayValue val={recnik_entity.value} /></td>
          <td></td>
          <td></td>
          <td></td>
          {
            _make_recnik_entity_cells_jsx(recnik_entity)
          }
        </tr>
      );
    });
  }
  */


  let jsxTableRowsRecnik_sasint_key = [];
  /*
  if (recnik !== false && recnik.subrecnik.sasint_key) {
    jsxTableRowsRecnikExtraArr = Object.keys(recnik.subrecnik.sasint_key).map((entity_key, index) => {
      const recnik_entity = multitranslator_v1_get_recnik_entity(recnik, "sasint_key", entity_key);
      return (
        <tr key={'extra_arr' + index}>
          <td></td>
          <td></td>
          <td className="td-multitranslations--blank"></td>
          <td className="val"><JSDisplayValue val={recnik_entity.value} /></td>
          <td></td>
          <td></td>
          <td></td>
          {
            _make_recnik_entity_cells_jsx(recnik_entity)
          }
        </tr>
      );
    });
  }
  */


  let jsxTableRowsRecnik_cncvars_key = [];
  /*
  if (recnik !== false && recnik.subrecnik.cncvars_key) {
    jsxTableRowsRecnik_cncvars_key = Object.keys(recnik.subrecnik.cncvars_key).map((entity_key, index) => {
      const recnik_entity = multitranslator_v1_get_recnik_entity(recnik, "cncvars_key", entity_key);
      return (
        <tr key={'extra_arr' + index}>
          <td></td>
          <td></td>
          <td className="td-multitranslations--blank"></td>
          <td className="val"><JSDisplayValue val={recnik_entity.value} /></td>
          <td></td>
          <td></td>
          <td></td>
          {
            _make_recnik_entity_cells_jsx(recnik_entity)
          }
        </tr>
      );
    });
  }
  */



  return (
    <ColumnWidthMinimize>
      <div className="frfr-js-display-object-widget frfr-js-display-object-widget--virtel">
        <div className="frfr-js-display-object-widget__xi-header">Object {'{}'} VIRTEL - bomlevel: {obj.bomlevel}&nbsp;&nbsp;virtelschemakey: {obj.virtelschemakey}&nbsp;&nbsp;subkey: {obj.subkey}&nbsp;&nbsp;parent_subkey: {obj.parent_subkey}</div>
        <div className="frfr-js-display-object-widget__xi-body">

          <JSDisplayWidgetCollapsibleHeight>
            <table className="frfr-js-table frfr-js-table--virtel">
              <thead>
                <tr>
                  <th className="sect">SECT</th>
                  <th className="sect">PODS</th>
                  <th className="">key</th>
                  <th className="val">value</th>
                  <th className="">TYPE</th>
                  <th className="">SIZE</th>
                  <th className="">DEC.</th>

                  {
                    recnik !== false && (
                      <>
                        <th className="">sasint_key</th>
                        {/*<th className="">sasint_value</th>*/}
                        <th className="">sasexcel_key</th>
                        <th className="">cncvars_key</th>
                        {/*<th className="">cncvars_value</th>*/}
                      </>
                    )
                  }
                </tr>
              </thead>
              <tbody>
                {jsxProgramRow}
                {jsxTableRows}
                {jsxTableRowsRecnikExtraArr}
                {jsxTableRowsRecnik_sasint_key}
                {jsxTableRowsRecnik_cncvars_key}
              </tbody>
            </table>
          </JSDisplayWidgetCollapsibleHeight>

        </div>
      </div>
    </ColumnWidthMinimize>
  );
};

export default JSDisplayObjectVirtel;